import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { EntityModelEditor as mainModule } from './main';
import * as $ from 'jquery';
import { init as mainTheme } from '../../../pdc-widget-entity-model-editor/src/ts/themes/main';

declare var require: any;
require('../sass-main/pdc-widget-entity-model-editor.sass');

export class EntityModelEditor extends WidgetBase {
    public static _name: string = 'Entity Model';
    public static group = 'Administrative';
    public static moduleName: string = 'pdc-widget-entity-model-editor';
    public static icon: string = 'plus';
    public static themeModule = mainTheme;

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-entity-model-editor'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(EntityModelEditor);
